import React from 'react'
import moment from 'moment'
import { useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom'

// components
import {
  CRow,
  CCol,
  CImage,
  CBadge,
  CFormText,
  CFormLabel
} from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'

// icons
import PurchaseBasketIcon from 'src/assets/icons/PurchaseBasketIcon.png'

// helpers
import { bookingStatus } from 'src/helpers/status-badge'
import formatCurrency from 'src/helpers/format-currency'

const CustomerBookingHistory = ({
  customerDetails,
  customerBookingHistory
}) => {
  const currency = useSelector((state) => state.currency)
  const navigate = useNavigate()

  return (
    <>
      {customerBookingHistory?.length > 0 ? (
        <>
          <h5 className="mt-3">{`${customerBookingHistory?.length} Completed Bookings`}</h5>
          <CRow className='customer-details-tab-container' xs={{ cols: 1, gutter: 2 }} md={{ cols: 2 }}>
            {customerBookingHistory?.map((booking, index) => {
              return (
                <CCol xs onClick={() => navigate(`/bookings/details/${booking?.booking?.id}`)} style={{ cursor: "pointer" }}>
                  <AppCard
                    className="mt-2"
                    headerTitle={
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <b>{`BOOKING NO: ${booking?.booking?.booking_uuid}`}</b> &nbsp; {moment(booking?.booking?.createdAt).format('DD/MM/YYYY HH:mm')}
                        </div>
                        <CBadge className='table-badge-status-content' color={bookingStatus(booking?.booking?.status)} shape="rounded-pill">
                          <b>{booking?.booking?.status?.toString().toUpperCase()}</b>
                        </CBadge>
                      </div>
                    }
                    bodyContent={
                      <CRow >
                        <CCol lg='9'>
                          <CFormLabel>{`${booking?.booking?.package?.service?.title} - ${booking?.booking?.package?.title?.split(' - ')[1]}`}</CFormLabel>
                          <CFormText><small>{`CONFIRMED DATE: ${moment(booking?.booking?.booking_time?.date).format('DD/MM/YYYY HH:mm')}`}</small></CFormText>
                        </CCol>
                        <CCol lg='3'>
                          <CFormLabel>Total Amount</CFormLabel>
                          <CFormText>{`${booking?.booking?.transaction_details && booking?.booking?.transaction_details?.length > 0 && formatCurrency(booking?.booking?.transaction_details[0]?.transaction_amount) ? `${currency && currency.code} ${formatCurrency(booking?.booking?.transaction_details[0]?.transaction_amount)}` : ''}`}</CFormText>
                        </CCol>
                      </CRow>
                    }
                    key={index}
                  />
                </CCol>
              )
            })}
          </CRow>
        </>
      ) : (
        <div className='my-5 text-center'>
          <CImage className='mb-3' fluid src={PurchaseBasketIcon} />
          <h5><b>No Booking History Yet</b></h5>
        </div>
      )}
    </>
  )
}

export default CustomerBookingHistory
